// extracted by mini-css-extract-plugin
export default {"lentaLogo":"styles_lenta-logo__04kuJ","lentaLogo__text":"styles_lenta-logo__text__SnauO"};